module.exports = __webpack_public_path__ + "img/drawings-banner.517db095.jpg";